// import React, { useEffect } from 'react';
// // import { useFileContext } from '../../../../Contexts/FileContext';
// // import ssoImg1 from "./../../../../assets/images/checklists-form-img.png";
// import pdfIcon from "./../../assets/images/pdf.png";
// import ssoImg1 from "./../../assets/images/checklists-form-img.png";
// import { WebApiURL } from './../../Constants/Constants';
// // import { useFileContext } from './../../Constants/FileContext';
// import { useFileContext } from './../../Contexts/FileContext';
// import { FaFilePdf } from "react-icons/fa";

// function CurrentTenders() {
//   const {
//     setComponentName,
//     documents,
//     loading,
//     setSection
//   } = useFileContext();

//   useEffect(() => {
//     setComponentName("ALL FORMS");
//     setSection("");
//   }, [setComponentName]);

//   const groupedDocs = documents.reduce((acc, doc) => {
//     const folder = doc.folderName || 'Uncategorized';
//     if (!acc[folder]) acc[folder] = [];
//     acc[folder].push(doc);
//     return acc;
//   }, {});

//   return (
//     <>
//       <div className="service-title font-700 mb-3 text-uppercase">
//         Current
//         <span className="text-orange-ef3e33 font-400"> Tenders </span>
//       </div>

//       <div className="row g-3 g-sm-4 g-md-4">
//         {/* <div className="col-lg-7">
//           <p className="text-primary-color mb-3">
//             PLEASE NOTE: “ Should the form show a “Please Wait…" ERROR MESSAGE, save/download the form to your device(desktop, laptop or phone) and open the form from there and not via your web browser”
//           </p>
//         </div> */}

//         {/* <div className="col-12">
//           <div className="checklists-form-wrap">
//             <div className="checklists-form">
//               <div className="checklists-form-img"><img src={ssoImg1} alt="" /></div>
//               <div className="checklists-form-field">
//                 <div className="font-17 font-600 mb-1 text-white">Search for forms, checklists or check sheets</div>
//                 <div className="row g-3 flex-column flex-sm-row">
//                   <div className="col">
//                     <input type="text" className="form-control height-50 border-0 rounded-0" placeholder="type your information here" />
//                   </div>
//                   <div className="col-auto">
//                     <button type="button" className="btn btn-submit height-50 rounded-0">Search</button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div> */}
//         <div className="col-12">
//           <div className="accordion blackTab" id="blackTab">

//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTabN1"
//                   aria-expanded="false"
//                   aria-controls="blackTabN1"
//                 >
//                   SAMSA/113/2025/26: THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                 </button>
//               </h2>
//               <div
//                 id="blackTabN1"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>                     
//                     BID NO: SAMSA/113/2025/26: REQUEST FOR PROPOSALS FROM ACCREDITED SERVICE PROVIDERS TO REPLACE THREE (3) DELL R730 AND ONE (1) R740 SERVERS WITH FOUR (4) NEW DELL R760 SERVERS, INCLUDING A 5-YEAR PROSUPPORT AND 4HR MISSION CRITICAL WARRANTY (60 MONTHS), AND TO PROCURE ONCE-OFF PROFESSIONAL SERVICES FOR IMPLEMENTATION BY CERTIFIED DELL, VMWARE, VEEAM, AND DELL STORAGE PARTNERS FOR SAMSA.
//                     </p>
//                   <p className="mb-3">
//                     <a href="/Documents/TenderDocs/RFP SAMSA 113-2025-26 Procurement of Servers Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />RFP SAMSA 113-2025-26 Procurement of Servers Final.pdf
//                     </a><br />
//                     {/* <a href="/Documents/TenderDocs/Tender register travel.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Tender register travel.pdf
//                     </a> */}
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     SAMSA/113/2025/26
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>
//                     19/09/2025
//                   </p>

//                   <p className="">
//                     <b className="d-block">Closing Date</b>
//                     13/10/2025 at 11:00
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab1"
//                   aria-expanded="false"
//                   aria-controls="blackTab1"
//                 >
//                   SAMSA-111-2025-26-THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab1"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>
//                     THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) WOULD LIKE TO INVITE PROPOSALS FOR AN OPEN TEXT ACCREDITED SERVICE PROVIDER FOR THE PROVISIONING OF ADVANCE SUPPORT AND MAINTENANCE OF THE SAMSA INTEGRATED OPERATIONS MANAGEMENT SYSTEM (SIOMS) INCLUDING IMPLEMENTATION OF IDENTIFIED ENHANCEMENT CAPABILITIES AS AND WHEN REQUIRED FOR A PERIOD OF 12 MONTHS​ </p>
//                   <p className="mb-3">
//                     <a href="/Documents/TenderDocs/RFP SAMSA 110-2025-26-2025  SIOMS final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                     </a><br />
//                     <a href="/Documents/TenderDocs/Tender register travel.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Tender register travel.pdf
//                     </a>
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     SAMSA/111/2025/26
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>
//                     22/07/2025
//                   </p>

//                   <p className="">
//                     <b className="d-block">Closing Date</b>
//                     13/08/2025 at 11:00
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab2"
//                   aria-expanded="true"
//                   aria-controls="blackTab2"
//                 >
//                   SAMSA-110-2025-26APPOINTMENT OF A PANEL OF RESEARCH ORGANISATIONS
//                 </button>
//               </h2>
//               <div
//                 id="blackTab2"
//                 className="accordion-collapse collapse show"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <div className="row g-3">
//                     <div className="col-md-12">
//                       {/* <p className="mb-3">
//                         <b className="d-block">Name ​of Institution </b>
//                         <strong>​​​South A​​frican Maritime Safety Authority (SAMSA)​ ​ </strong>
//                         ​
//                         </p> */}
//                       <p className="mb-3">
//                         <b className="d-block">​Description </b>
//                         APPOINTMENT OF A PANEL OF RESEARCH ORGANISATIONS FOR THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) FOR A PERIOD OF THREE (3) YEARS
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/TenderDocs/Tender register travel.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />Tender register travel.pdf
//                         </a>< br />
//                         <a href="/Documents/TenderDocs/TRAVEL MANAGEMENT SERVICES TENDER DOCUMENT 15 MAR 2024.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />TRAVEL MANAGEMENT SERVICES TENDER DOCUMENT 15 MAR 2024.pdf
//                         </a>
//                       </p>



//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/110/2025/26
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>
//                         23/07/2025
//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         15/08/2025 at 11:00
//                       </p>


//                     </div>


//                   </div>

//                 </div>
//               </div>
//             </div>

//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab3"
//                   aria-expanded="false"
//                   aria-controls="blackTab3"
//                 >
//                   SAMSA096202324-APPOINTMENT-OF-TRAVEL-MANAGEMENT-COMPANY-TO-PROVIDE-TRAVEL-MANAGEMENT-SERVICES-FOR-THE-SOUTH-AFRICAN-MARITIM
//                 </button>
//               </h2>
//               <div
//                 id="blackTab3"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>
//                     APPOINTMENT OF A TRAVEL MANAGEMENT SERVICES FOR A PERIOD OF FIVE YEARS FOR THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) .
//                   </p>
//                   <p className="mb-3">
//                     <a href="/Documents/TenderDocs/TRAVEL MANAGEMENT SERVICES TENDER DOCUMENT 15 MAR 2024 (1).pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />TRAVEL MANAGEMENT SERVICES TENDER DOCUMENT 15 MAR 2024 (1).pdf
//                     </a>< br />
//                     <a href="/Documents/TenderDocs/Tender register travel (1).pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Tender register travel (1).pdf
//                     </a>
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     SAMSA/096/2023/24
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>

//                   </p>

//                   <p className="">
//                     <b className="d-block">Closing Date</b>
//                     17/04/2024 at 11H00 a.m.
//                   </p>
//                 </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab6"
//                   aria-expanded="false"
//                   aria-controls="blackTab6"
//                 >
//                   THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY(SAMSA) WOULD LIKE TO INVITE SUITABLE SERVICE PROVIDER(S)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab6"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>
//                     SAMSA/109/2025/26: THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) WOULD LIKE TO INVITE PROPOSALS FOR THE APPOINTMENT OF A SERVICE PROVIDER TO CONDUCT AN ORGANISATIONAL DESIGN/STRUCTURE REVIEW
//                      </p>
//                   <p className="mb-3">
//                     <a href="/Documents/TenderDocs/RFP SAMSA 109-2025-26-2025 Org redesign_final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />RFP SAMSA 109-2025-26-2025 Org redesign_final.pdf
//                     </a>< br />
//                     <a href="/Documents/TenderDocs/Tender Register Org.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Tender Register Org.pdf
//                     </a>
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     SAMSA/109/2025/26:
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>
//                     09/07/2025
//                   </p>

//                   <p className="">
//                     <b className="d-block">Closing Date</b>
//                    31/07/2025 at 11:00
//                   </p>
//                   {/* <p className="">
//                     <b className="d-block"><b className="d-block">​​​Briefing session – Non-compulsory​</b></b>
//                     <b className="d-block"><b className="d-block">​​ Venue: Virtual via Microsoft Teams</b></b>
//                     <b className="d-block"><b className="d-block">​​ Date: 19 June 2025</b></b>
//                     <b className="d-block"><b className="d-block">​​ Time: 11h30 – 12h30</b></b>
//                     <b className="d-block"><b className="d-block">​​ </b>Join the meeting now </b>
//                     <b className="d-block"><b className="d-block">​​ </b>Meeting ID: 362 008 509 978 8 </b>
//                     Passcode: vd2eY2fF
//                   </p> */}
//                   {/* <p className="mb-3">
//                     <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                     </a>
//                   </p> */}



//                 </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab7"
//                   aria-expanded="false"
//                   aria-controls="blackTab7"
//                 >
//                  	BID-NOSAMSA076202324-FOR-THE-APPOINTMENT-OF-A-PANEL-OF-SERVICE-PROVIDERS-(SUPPLIERS)-TO-PROVIDE-SAMSA-MARITIME-SPECIAL-PRO
//                 </button>
//               </h2>
//               <div
//                 id="blackTab7"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>
//                    BID NO: SAMSA/077/2023/24: FOR THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH FISHING AND SEAMANSHIP GEAR - ROPES TACKLE NETS FOR DURBAN HABOUR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF. ​
//                    </p>
//                   <p className="mb-3">
//                     <a href="/Documents/TenderDocs/TENDER DOCUMENT FISHING DURBAN.doc" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />TENDER DOCUMENT FISHING DURBAN.doc
//                     </a>< br />
//                     <a href="/Documents/TenderDocs/Fishing and Seaman Durban.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Fishing and Seaman Durban.pdf
//                     </a>
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     SAMSA/077/2023/24
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>
//                     20/06/2025
//                   </p>

//                   <p className="">
//                     <b className="d-block">Closing Date</b>
//                     30/01/ 2024 at 11H00 a.m.
//                   </p>
//                   {/* <p className="">
//                     <b className="d-block">COMPULSORY INFORMATION SESSION:</b>
//                     Date: 30 June 2025<br />Time:10H00-11H00
//                   </p>
//                   <p className="">
//                     <b className="d-block">Place: South African Maritime Safety Authority (SAMSA) Head Office</b>
//                     146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />Hillcrest<br />0183
//                   </p> */}
//                 </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab8"
//                   aria-expanded="false"
//                   aria-controls="blackTab8"
//                 >
//                   SAMSA-112-2025-26THE-SOUTH-AFRICAN-MARITIME-SAFETY-AUTHORITY-(SAMSA)-WOULD-LIKE-TO-INVITE-PROPOSALS-FOR-THE-RENEWAL-OFVEEAM
//                 </button>
//               </h2>
//               <div
//                 id="blackTab8"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>
//                     ​​THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) WOULD LIKE TO INVITE PROPOSALS FOR THE RENEWAL OF VEEAM BACKUP AND REPLICATION LICENSES FOR 3 YEARS.
//                     </p>
//                   <p className="mb-3">
//                     {/* <a href="/Documents/TenderDocs/TENDER DOCUMENT FISHING DURBAN.doc" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />TENDER DOCUMENT FISHING DURBAN.doc
//                     </a>< br /> */}
//                     <a href="/Documents/TenderDocs/RFP SAMSA 112-2025-26 - VEEAM.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />RFP SAMSA 112-2025-26 - VEEAM.pdf
//                     </a>
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     SAMSA/112/2025/26
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>
//                    31/07/2025
//                   </p>

//                   <p className="">
//                     <b className="d-block">Closing Date</b>
//                     22/08/2025 at 11:00
//                   </p>
//                 </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab9"
//                   aria-expanded="false"
//                   aria-controls="blackTab9"
//                 >
//                   THE-SOUTH-AFRICAN-MARITIME-SAFETY-AUTHORITY(SAMSA)-WOULD-LIKE-TO-INVITE-SUITABLE-SERVICE-PROVIDER(S)-FOR-THE-IMPLEMENTATIO
//                 </button>
//               </h2>
//               <div
//                 id="blackTab9"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>
//                     ADDENDUM TO RFP NUMBER SAMSA/108/2025/26 – THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY(SAMSA) WOULD LIKE TO INVITE SUITABLE SERVICE PROVIDER(S) FOR THE IMPLEMENTATION OF CRY​PTOGRAPHIC AND KEY MANAGEMENT SYSTEM INCLUDING MAINTENANCE AND SUPPORT FOR A PERIOD OF THREE (3) YEARS
//                     </p>
//                   <p className="mb-3">
//                     <a href="/Documents/TenderDocs/Addendum to tender  - SAMSA Cryptographic Services.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Addendum to tender  - SAMSA Cryptographic Services
//                     </a>< br />
//                     <a href="/Documents/TenderDocs/RFP SAMSA 108 2025-26 Cryptographic & Key Management Services  - updated.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />RFP SAMSA 108 2025-26 Cryptographic & Key Management Services  - updated.pdf
//                     </a>
//                     < br />
//                     <a href="/Documents/TenderDocs/Tender register, Cryptography.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Tender register, Cryptography.pdf
//                     </a>
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     SAMSA/108/2025/26
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>
//                     11/06/2025
//                   </p>
//                   <p className="mb-3">
//                     <b className="d-block">Closing Date</b>
//                     11/07/2025 at 11:00
//                   </p>                
//                 </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab10"
//                   aria-expanded="false"
//                   aria-controls="blackTab10"
//                 >
//                  ​THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY(SAMSA) WOULD LIKE TO INVITE SUITABLE SERVICE PROVIDER(S) FOR THE IMPLEMENTATION OF CRYPTOGRAPHIC AND KEY MANAGEMENT SYSTEM INCLUDING MAINTENANCE AND SUPPORT FOR A PERIOD OF THREE (3) YEARS​ ​ ​
//                  </button>
//               </h2>
//               <div
//                 id="blackTab10"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>
//                     ​THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY(SAMSA) WOULD LIKE TO INVITE SUITABLE SERVICE PROVIDER(S) FOR THE IMPLEMENTATION OF CRYPTOGRAPHIC AND KEY MANAGEMENT SYSTEM INCLUDING MAINTENANCE AND SUPPORT FOR A PERIOD OF THREE (3) YEARS​ ​ ​
//                     </p>
//                   <p className="mb-3">
//                     <a href="/Documents/TenderDocs/Addendum to tender  - SAMSA Cryptographic Services1.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Addendum to tender  - SAMSA Cryptographic Services1
//                     </a>< br />
//                     <a href="/Documents/TenderDocs/RFP SAMSA 108 2025-26 Cryptographic & Key Management Services  - updated (1).pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />RFP SAMSA 108 2025-26 Cryptographic & Key Management Services  - updated (1)
//                     </a>

//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     ​​SAMSA/108/2025/26 ​ ​ ​
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>
//                     10/06/2025
//                   </p>
//                   <p className="mb-3">
//                     <b className="d-block">Closing Date</b>
//                     04/07/2025 at 11:00
//                   </p>                
//                 </div>
//               </div>
//             </div>

//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab11"
//                   aria-expanded="false"
//                   aria-controls="blackTab11"
//                 >
//                 ​​ADDENDUM TO RFP NUMBER SAMSA/105/2025/26 - REQUEST FOR PROSPECTIVE BIDDERS TO SUBMIT A PROPOSAL FOR
//                 </button>
//               </h2>
//               <div
//                 id="blackTab11"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>
//                     ADDENDUM TO RFP NUMBER SAMSA/105/2025/26 - REQUEST FOR PROSPECTIVE BIDDERS TO SUBMIT A PROPOSAL FOR A COMPREHENSIVE SECURITY GUARDING SOLUTION FOR SAMSA HEAD OFFICE FOR A PERIOD OF TWO (2) YEARS TEN (10) MONTHS, COMMENCING ON 01 OCTOBER 2025 UNTIL 31 JULY 2028. ​ ​
//                     </p>
//                   <p className="mb-3">
//                     <a href="/Documents/TenderDocs/RFP SAMSA 105-23-06-2025 Security Guarding Services _REV1.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />RFP SAMSA 105-23-06-2025 Security Guarding Services _REV1
//                     </a>< br />
//                     <a href="/Documents/TenderDocs/Addendum_SAMSA HO Security Tender.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Addendum_SAMSA HO Security Tender
//                     </a>< br />
//                     <a href="/Documents/TenderDocs/Security Tender register.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Security Tender register
//                     </a>

//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     ​​SAMSA/105/2025/26 
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>
//                     20/06/2025
//                   </p>
//                   <p className="mb-3">
//                     <b className="d-block">Closing Date</b>
//                     11/07/2025 at 11:00
//                   </p>                
//                 </div>
//               </div>
//             </div>

//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab12"
//                   aria-expanded="false"
//                   aria-controls="blackTab12"
//                 >
//                   ​REQUEST FOR PROSPECTIVE BIDDERS TO SUBMIT A PROPOSAL FOR A COMPREHENSIVE SECURITY GUARDING SOLUTION
//                 </button>
//               </h2>
//               <div
//                 id="blackTab12"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                     <b className="d-block">​Description</b>
//                     ​REQUEST FOR PROSPECTIVE BIDDERS TO SUBMIT A PROPOSAL FOR A COMPREHENSIVE SECURITY GUARDING SOLUTION FOR SAMSA HEAD OFFICE FOR A PERIOD OF TWO (2) YEARS TEN (10) MONTHS, COMMENCING ON 01 OCTOBER 2025 UNTIL 31 JULY 2028.
//                     </p>
//                   <p className="mb-3">
//                     <a href="/Documents/TenderDocs/SAMSA105-2025-06_HO Security Tender.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />SAMSA105-2025-06_HO Security Tender
//                     </a>< br />
//                     <a href="/Documents/TenderDocs/RFP SAMSA 105-23-06-2025 Security Guarding Services Updated.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />RFP SAMSA 105-23-06-2025 Security Guarding Services Updated
//                     </a>< br />
//                     <a href="/Documents/TenderDocs/Addendum SAMSA Security Guards Services.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                       <FaFilePdf style={{ marginRight: "5px" }} />Addendum SAMSA Security Guards Services
//                     </a>

//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">SBid number</b>
//                     SAMSA/105/2025/26
//                   </p>

//                   <p className="mb-3">
//                     <b className="d-block">Advert date</b>
//                    20/06/2025
//                   </p>
//                   <p className="mb-3">
//                     <b className="d-block">Closing Date</b>
//                    11/07/2025 at 11:00
//                   </p>                
//                 </div>
//               </div>
//             </div>





//             {/* <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTabThree"
//                   aria-expanded="false"
//                   aria-controls="blackTabThree"
//                 >
//                   Permitting prohibited colours etc to be hoisted on a South African Ship
//                 </button>
//               </h2>
//               <div
//                 id="blackTabThree"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description of offence</b>
//                         Failing to hoist the National Flag on South African Ship
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Section / Item</b>
//                         4(2) read with 52(1) & (2)
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Person(s) liable</b>
//                         Master
//                       </p>

//                       <p className="">
//                         <b className="d-block">Penalty</b>
//                         R40 000 or 2 years
//                       </p>
//                 </div>
//               </div>
//             </div> */}

//             {/* <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTabFour"
//                   aria-expanded="false"
//                   aria-controls="blackTabFour"
//                 >
//                   Unlawfully causing ship to appear to be a South African ship.
//                 </button>
//               </h2>
//               <div
//                 id="blackTabFour"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description of offence</b>
//                         Failing to hoist the National Flag on South African Ship
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Section / Item</b>
//                         4(2) read with 52(1) & (2)
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Person(s) liable</b>
//                         Master
//                       </p>

//                       <p className="">
//                         <b className="d-block">Penalty</b>
//                         R40 000 or 2 years
//                       </p>
//                 </div>
//               </div>
//             </div> */}

//             {/* <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTabFive"
//                   aria-expanded="false"
//                   aria-controls="blackTabFive"
//                 >
//                   Unlawfully concealing etc nationality of South African ship.
//                 </button>
//               </h2>
//               <div
//                 id="blackTabFive"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description of offence</b>
//                         Failing to hoist the National Flag on South African Ship
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Section / Item</b>
//                         4(2) read with 52(1) & (2)
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Person(s) liable</b>
//                         Master
//                       </p>

//                       <p className="">
//                         <b className="d-block">Penalty</b>
//                         R40 000 or 2 years
//                       </p>
//                 </div>
//               </div>
//             </div> */}
//           </div>
//         </div>

//         <div className="col-12">
//           {loading ? (
//             <div>Loading Tenders...</div>
//           ) : (
//             <ul className="strip-ul mt-3">
//               {Object.entries(groupedDocs).map(([folderName, docs], index) => (
//                 <li className="bg-transparent p-0" key={index}>
//                   <div className="row g-4">
//                     {/* <div className="col-auto">
//                       <img src={pdfIcon} alt="PDF icon" />
//                     </div> */}
//                     <div className="col">
//                       <div className="row g-4">
//                         <div className="col-md">
//                           {/* <div className="font-18 font-600">Tenders Name</div> */}
//                           <div className="font-16 font-400">
//                             {/* <p className="text-orange-ef3e33 text-uppercase">{folderName}</p> */}
//                             {/* <ul className="list">
//                               {docs.map((item, i) => (
//                                 <li key={i}>
//                                   <a
//                                     href={`${WebApiURL}File/view/${encodeURIComponent(item.fileId)}`}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                   >
//                                     {item.fileName}
//                                   </a>
//                                 </li>
//                               ))}
//                             </ul> */}
//                           </div>
//                         </div>
//                         {/* <div className="col-md-auto">
//                           <div className="font-18 font-600">Tender Opening Date</div>
//                           <div className="font-16 font-400">
//                             {docs[0]?.modifiedDate ? new Date(docs[0].modifiedDate).toLocaleString() : '—'}
//                           </div>
//                         </div>
//                          <div className="col-md-auto">
//                           <div className="font-18 font-600">Tender Closing Date</div>
//                           <div className="font-16 font-400">
//                             {docs[0]?.modifiedDate ? new Date(docs[0].modifiedDate).toLocaleString() : '—'}
//                           </div>
//                         </div> */}
//                       </div>
//                     </div>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }


// export default CurrentTenders;


//New Code With API

// import React, { useEffect, useState } from "react";
// import { useFileContext } from "./../../Contexts/FileContext";
// import { WebApiURL } from "./../../Constants/Constants";

// function CurrentTenders() {
//     const { setComponentName, setSection } = useFileContext();
//     const [tenders, setTenders] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         setComponentName("ALL FORMS");
//         setSection("");

//         // ✅ Fetch tenders from backend API
//         const fetchTenders = async () => {
//             try {
//                 const response = await fetch(`${WebApiURL}Tender/all`);
//                 const data = await response.json();

//                 console.log("Data returned from backend", data);

//                 // ✅ Only keep Current Tenders
//     const current = (data || []).filter(
//       (t) => t.component === "Current Tenders"
//     );

//                 setTenders(current || []);
//             } catch (error) {
//                 console.error("Error fetching tenders:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchTenders();
//     }, [setComponentName, setSection]);

//     const tableStyle = {
//         width: "100%",
//         borderCollapse: "collapse",
//         fontFamily: "Arial, sans-serif",
//     };

//     const thStyle = {
//         backgroundColor: "#008B8B", // Teal header
//         color: "white",
//         padding: "10px",
//         textAlign: "left",
//         fontWeight: "bold",
//         border: "1px solid #ccc",
//     };

//     const tdStyle = {
//         padding: "10px",
//         border: "1px solid #ccc",
//     };

//     const rowEven = { backgroundColor: "#F9F9F9" };

//     return (
//         <>
//             <div className="service-title font-700 mb-3 text-uppercase">
//                 Current
//                 <span className="text-orange-ef3e33 font-400"> Tenders </span>
//             </div>

//             {loading ? (
//                 <div>Loading Tenders...</div>
//             ) : (
//                 <div className="row g-3 g-sm-4 g-md-4">
//                     <div className="col-12">
//                         <div className="accordion blackTab" id="blackTab">
//                             {tenders.map((tender, index) => (
//                                 <div className="accordion-item" key={index}>
//                                     <h2 className="accordion-header">
//                                         <button
//                                             className="accordion-button collapsed"
//                                             type="button"
//                                             data-bs-toggle="collapse"
//                                             data-bs-target={`#tender-${index}`}
//                                             aria-expanded="false"
//                                             aria-controls={`tender-${index}`}
//                                         >
//                                              {tender.section }
//                                         </button>
//                                     </h2>
//                                     <div
//                                         id={`tender-${index}`}
//                                         className="accordion-collapse collapse"
//                                         data-bs-parent="#blackTab"
//                                     >
//                                         <div style={{ padding: "2px" }}>



//                                             <div dangerouslySetInnerHTML={{ __html: tender.fileHTMLContent }} />



//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// }

// export default CurrentTenders;



//like RFQ



// import React, { useEffect, useState } from "react";
// import { useFileContext } from "./../../Contexts/FileContext";
// import { WebApiURL } from "./../../Constants/Constants";

// function CurrentTenders() {
//     const { setComponentName, setSection } = useFileContext();
//     const [tenders, setTenders] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         setComponentName("ALL FORMS");
//         setSection("");

//         // ✅ Fetch tenders from backend API
//         const fetchTenders = async () => {
//             try {
//                 const response = await fetch(`${WebApiURL}Tender/all`);
//                 const data = await response.json();

//                 console.log("Data returned from backend", data);

//                 // ✅ Only keep Current Tenders
//                 const current = (data || []).filter(
//                     (t) => t.component === "Current Tenders"
//                 );

//                 setTenders(current || []);
//             } catch (error) {
//                 console.error("Error fetching tenders:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchTenders();
//     }, [setComponentName, setSection]);

//     const tableStyle = {
//         width: "100%",
//         borderCollapse: "collapse",
//         fontFamily: "Arial, sans-serif",
//     };

//     const thStyle = {
//         backgroundColor: "#008B8B", // Teal header
//         color: "white",
//         padding: "10px",
//         textAlign: "left",
//         fontWeight: "bold",
//         border: "1px solid #ccc",
//     };

//     const tdStyle = {
//         padding: "10px",
//         border: "1px solid #ccc",
//     };
//     const rowEven = { backgroundColor: "#F9F9F9" };

//     return (
//         <>
//             <div className="service-title font-700 mb-3 text-uppercase">
//                 Current
//                 <span className="text-orange-ef3e33 font-400"> Tenders </span>
//             </div>

//             {loading ? (
//                 <div>Loading Tenders...</div>
//             ) : (
//                 <div className="row g-3 g-sm-4 g-md-4">
//                     <div className="col-12">
//                         <div className="accordion blackTab" id="blackTab">
//                             {tenders.map((tender, index) => (
//                                 <div className="accordion-item" key={index}>
//                                     {/* <h2 className="accordion-header">
//                                         <button
//                                             className="accordion-button collapsed"
//                                             type="button"
//                                             data-bs-toggle="collapse"
//                                             data-bs-target={`#tender-${index}`}
//                                             aria-expanded="false"
//                                             aria-controls={`tender-${index}`}
//                                         >
//                                             {tender.section}
//                                             {tender.openDate}
//                                             {tender.closingDate}
//                                             {tender.status}

//                                         </button>
//                                     </h2> */}
//                                     <h2 className="accordion-header">
//                                         <button
//                                             className="accordion-button collapsed"
//                                             type="button"
//                                             data-bs-toggle="collapse"
//                                             data-bs-target={`#tender-${index}`}
//                                             aria-expanded="false"
//                                             aria-controls={`tender-${index}`}
//                                         >
//                                             <div className="row w-100 m-0">
//                                                 {/* Section Name */}
//                                                 <div className="col-12 col-md-6 fw-semibold">
//                                                     <span>{tender.section}</span>
//                                                 </div>

//                                                 {/* Open Date */}
//                                                 <div className="col-12 col-md-2 text-md">
//                                                     <span className="d-none d-md-inline fw-semibold">Open Date: </span><br />
//                                                     <span>
//                                                         {tender.openDate && !isNaN(new Date(tender.openDate))
//                                                             ? new Date(tender.openDate).toLocaleDateString("en-GB")
//                                                             : ""}
//                                                     </span>
//                                                 </div>

//                                                 {/* Closing Date & Time */}
//                                                 <div className="col-12 col-md-3 text-md">
//                                                     <span className="d-none d-md-inline fw-semibold">Close Date & Time: </span><br />
//                                                     <span>
//                                                         {tender.closingDate && !isNaN(new Date(tender.closingDate))
//                                                             ? new Date(tender.closingDate).toLocaleString("en-GB", {
//                                                                 day: "2-digit",
//                                                                 month: "2-digit",
//                                                                 year: "numeric",
//                                                                 hour: "2-digit",
//                                                                 minute: "2-digit"
//                                                             })
//                                                             : ""}
//                                                     </span>
//                                                 </div>

//                                                 {/* Status */}
//                                                 <div className="col-12 col-md-1 text-md-end">
//                                                     <span className="d-none d-md-inline fw-semibold">Status: </span><br />
//                                                     <span>{tender.status || ""}</span>
//                                                 </div>
//                                             </div>
//                                         </button>
//                                     </h2>

//                                     <div
//                                         id={`tender-${index}`}
//                                         className="accordion-collapse collapse"
//                                         data-bs-parent="#blackTab"
//                                     >
//                                         <div style={{ padding: "2px" }}>



//                                             <div dangerouslySetInnerHTML={{ __html: tender.fileHTMLContent }} />



//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// }

// export default CurrentTenders;

// With Search and new design


// import React, { useEffect, useState } from "react";
// import { useFileContext } from "./../../Contexts/FileContext";
// import { WebApiURL } from "./../../Constants/Constants";

// function CurrentTenders() {
//     const { setComponentName, setSection } = useFileContext();
//     const [tenders, setTenders] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         setComponentName("ALL FORMS");
//         setSection("");

//         // ✅ Fetch tenders from backend API
//         const fetchTenders = async () => {
//             try {
//                 const response = await fetch(`${WebApiURL}Tender/all`);
//                 const data = await response.json();

//                 console.log("Data returned from backend", data);

//                 // ✅ Only keep Current Tenders
//                 const current = (data || []).filter(
//                     (t) => t.component === "Current Tenders"
//                 );

//                 setTenders(current || []);
//             } catch (error) {
//                 console.error("Error fetching tenders:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchTenders();
//     }, [setComponentName, setSection]);

//     const tableStyle = {
//         width: "100%",
//         borderCollapse: "collapse",
//         fontFamily: "Arial, sans-serif",
//     };

//     const thStyle = {
//         backgroundColor: "#008B8B", // Teal header
//         color: "white",
//         padding: "10px",
//         textAlign: "left",
//         fontWeight: "bold",
//         border: "1px solid #ccc",
//     };

//     const tdStyle = {
//         padding: "10px",
//         border: "1px solid #ccc",
//     };
//     const rowEven = { backgroundColor: "#F9F9F9" };

//     return (
//         <>
//             <div className="service-title font-700 mb-3 text-uppercase">
//                 Current
//                 <span className="text-orange-ef3e33 font-400"> Tenders </span>
//             </div>

//             {loading ? (
//                 <div>Loading Tenders...</div>
//             ) : (
//                 <div className="row g-3 g-sm-4 g-md-4">
//                     <div className="col-12">
//                         <div className="accordion blackTab" id="blackTab">
//                             {tenders.map((tender, index) => (
//                                 <div className="accordion-item" key={index}>                                    
//                                     <h2 className="accordion-header">
//                                         <button
//                                             className="accordion-button collapsed"
//                                             type="button"
//                                             data-bs-toggle="collapse"
//                                             data-bs-target={`#tender-${index}`}
//                                             aria-expanded="false"
//                                             aria-controls={`tender-${index}`}
//                                         >
//                                             <div className="row w-100 m-0">
//                                                 {/* Section Name */}
//                                                 <div className="col-12 col-md-6 fw-semibold">
//                                                     <span>{tender.section}</span>
//                                                 </div>

//                                                 {/* Open Date */}
//                                                 <div className="col-12 col-md-2 text-md">
//                                                     <span className="d-none d-md-inline fw-semibold">Open Date: </span><br />
//                                                     <span>
//                                                         {tender.openDate && !isNaN(new Date(tender.openDate))
//                                                             ? new Date(tender.openDate).toLocaleDateString("en-GB")
//                                                             : ""}
//                                                     </span>
//                                                 </div>

//                                                 {/* Closing Date & Time */}
//                                                 <div className="col-12 col-md-3 text-md">
//                                                     <span className="d-none d-md-inline fw-semibold">Close Date & Time: </span><br />
//                                                     <span>
//                                                         {tender.closingDate && !isNaN(new Date(tender.closingDate))
//                                                             ? new Date(tender.closingDate).toLocaleString("en-GB", {
//                                                                 day: "2-digit",
//                                                                 month: "2-digit",
//                                                                 year: "numeric",
//                                                                 hour: "2-digit",
//                                                                 minute: "2-digit"
//                                                             })
//                                                             : ""}
//                                                     </span>
//                                                 </div>

//                                                 {/* Status */}
//                                                 <div className="col-12 col-md-1 text-md-end">
//                                                     <span className="d-none d-md-inline fw-semibold">Status: </span><br />
//                                                     <span>{tender.status || ""}</span>
//                                                 </div>
//                                             </div>
//                                         </button>
//                                     </h2>
//                                     <div
//                                         id={`tender-${index}`}
//                                         className="accordion-collapse collapse"
//                                         data-bs-parent="#blackTab"
//                                     >
//                                         <div style={{ padding: "2px" }}>
//                                             <div dangerouslySetInnerHTML={{ __html: tender.fileHTMLContent }} />
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// }

// export default CurrentTenders;

import React, { useEffect, useState, useRef, useMemo } from "react";
import { useFileContext } from "./../../Contexts/FileContext";
import { WebApiURL } from "./../../Constants/Constants";

function CurrentTenders() {
  const { setComponentName, setSection } = useFileContext();
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const printRef = useRef(null);

  useEffect(() => {
    setComponentName("ALL FORMS");
    setSection("");

    // ✅ Fetch tenders from backend API
    const fetchTenders = async () => {
      try {
        const response = await fetch(`${WebApiURL}Tender/all`);
        const data = await response.json();

        // ✅ Only keep Current Tenders
        const current = (data || []).filter(
          (t) => t.component === "Current Tenders"
        );

        setTenders(current || []);
      } catch (error) {
        console.error("Error fetching tenders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTenders();
  }, [setComponentName, setSection]);

  // 🔍 Search filter (section, status, openDate, closingDate)
  const filteredTenders = useMemo(() => {
    if (!searchTerm) return tenders;
    const term = searchTerm.toLowerCase();

    return tenders.filter((t) => {
      const section = (t.section || "").toString().toLowerCase();
      const status = (t.status || "").toString().toLowerCase();

      const openDateStr =
        t.openDate && !isNaN(new Date(t.openDate))
          ? new Date(t.openDate)
              .toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
              .toLowerCase()
          : "";

      const closingDateStr =
        t.closingDate && !isNaN(new Date(t.closingDate))
          ? new Date(t.closingDate)
              .toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
              .toLowerCase()
          : "";

      return (
        section.includes(term) ||
        status.includes(term) ||
        openDateStr.includes(term) ||
        closingDateStr.includes(term)
      );
    });
  }, [searchTerm, tenders]);

  // 🖨️ Print Handler
  const handlePrint = () => {
    if (!printRef.current) return;
    const printContent = printRef.current.innerHTML;
    const newWindow = window.open("", "", "width=1200,height=650");
    newWindow.document.write(`
      <html>
        <head>
          <title>Print Preview - Current Tenders</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .accordion-button { background: #f8f9fa; font-weight: bold; }
            .accordion-item { border: 1px solid #ddd; margin-bottom: 10px; border-radius: 6px; }
            .accordion-body { padding: 10px 20px; }
            .tender-header { display: none !important; }
            .accordion-button { display: block; text-align: left; width: 100%; }
          </style>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };

  return (
    <>
      {/* Header and Search/Print Controls */}
      <div className="service-title font-700 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
        <div>
          Current <span className="text-orange-ef3e33 font-400">Tenders</span>
        </div>

        <div className="d-flex flex-wrap gap-2">
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ width: "260px" }}
            placeholder="Search by section, status, or date..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            className="about-btn btn-green-38B652 text-decoration-none"
            onClick={handlePrint}
          >
            Print
          </button>
        </div>
      </div>

      {loading ? (
        <div>Loading Tenders...</div>
      ) : filteredTenders.length === 0 ? (
        <div>No matching tenders found.</div>
      ) : (
        <div className="row g-3 g-sm-4 g-md-4" ref={printRef}>
          <div className="col-12">
            <div className="accordion blackTab" id="blackTab">
              {filteredTenders.map((tender, index) => (
                <div className="accordion-item" key={index}>
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#tender-${index}`}
                      aria-expanded="false"
                      aria-controls={`tender-${index}`}
                    >
                      <div className="row w-100 m-0">
                        {/* Section */}
                        <div className="col-12 col-md-6 fw-semibold">
                          <span>{tender.bidNumber}</span><br />
                          <span>{tender.section}</span>
                        </div>

                        {/* Open Date */}
                        <div className="col-12 col-md-2 text-md">
                          <span className="d-none d-md-inline fw-semibold">
                            Open Date:
                          </span>
                          <br />
                          <span>
                            {tender.openDate &&
                            !isNaN(new Date(tender.openDate))
                              ? new Date(
                                  tender.openDate
                                ).toLocaleDateString("en-GB")
                              : ""}
                          </span>
                        </div>

                        {/* Close Date */}
                        <div className="col-12 col-md-3 text-md">
                          <span className="d-none d-md-inline fw-semibold">
                            Close Date & Time:
                          </span>
                          <br />
                          <span>
                            {tender.closingDate &&
                            !isNaN(new Date(tender.closingDate))
                              ? new Date(
                                  tender.closingDate
                                ).toLocaleString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : ""}
                          </span>
                        </div>

                        {/* Status */}
                        <div className="col-12 col-md-1 text-md-end">
                          <span className="d-none d-md-inline fw-semibold">
                            Status:
                          </span>
                          <br />
                          <span>{tender.status || ""}</span>
                        </div>
                      </div>
                    </button>
                  </h2>
                  <div
                    id={`tender-${index}`}
                    className="accordion-collapse collapse"
                    data-bs-parent="#blackTab"
                  >
                    <div style={{ padding: "8px" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: tender.fileHTMLContent,
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CurrentTenders;
